module.exports = __webpack_public_path__ + "img/icon_stop.f4f1b7df.png";